<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents" style="">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <lookbook-write-component :lookbook-type="'hashUpdate'"
                                              :lookbookKey="lookbookKey"></lookbook-write-component>
                    <div class="text-center pt10">
                        <el-button @click="submitForm()" type="primary">저장</el-button>
                        <el-button @click="deleteForm()" type="danger">삭제</el-button>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "../../mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
import LookbookWriteComponent from "@/components/lookbook/LookbookWriteComponent";

export default {
    name: 'LookbookHashDetail',
    components: {
        LookbookWriteComponent,
    },
    mixins: [alertMixins],
    data() {
        return {
            lookbookKey: this.$route.params.lh_idx,
        }
    },
    mounted() {
    },
    methods: {
        submitForm() {
            EventBus.$emit('writeLookbook');
        },
        deleteForm() {
            this.openDeleteConfirm({
                confirm: (value) => {
                    EventBus.$emit('writeDeleteLookbook', this.lookbookKey, value);
                },
                cancel: () => {
                }
            })

        },
    },
    watch: {}
}
</script>
